var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPuja(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_5851963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5254 12.9128H28.3159C30.1242 10.3495 26.2564 4.44128 24.574 2.33684L24.6037 2.31306C24.3687 1.99278 24.1234 1.66488 23.8641 1.32707L23.5257 0.886169L23.1567 1.30183C23.0418 1.43117 21.9301 2.69613 20.7711 4.43531C19.0434 7.10862 17.1554 10.9706 18.5254 12.9128Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5254 12.9128H28.3159C30.1242 10.3495 26.2564 4.44128 24.574 2.33684L24.6037 2.31306C24.3687 1.99278 24.1234 1.66488 23.8641 1.32707L23.5257 0.886169L23.1567 1.30183C23.0418 1.43117 21.9301 2.69613 20.7711 4.43531C19.0434 7.10862 17.1554 10.9706 18.5254 12.9128Z",
    fill: "url(#paint0_linear_240_14966)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1977 6.26255C29.6899 9.14139 30.0827 11.3721 29.3734 12.9129H31.946C32.4538 11.18 32.3848 8.9309 31.7366 6.21114C31.21 4.0026 30.2012 1.59119 30.2012 1.59119L29.7485 1.77974C28.6797 2.22716 27.581 3.08821 26.7615 3.82314C27.2224 4.52648 27.7319 5.36395 28.1977 6.26255Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1977 6.26255C29.6899 9.14139 30.0827 11.3721 29.3734 12.9129H31.946C32.4538 11.18 32.3848 8.9309 31.7366 6.21114C31.21 4.0026 30.2012 1.59119 30.2012 1.59119L29.7485 1.77974C28.6797 2.22716 27.581 3.08821 26.7615 3.82314C27.2224 4.52648 27.7319 5.36395 28.1977 6.26255Z",
    fill: "url(#paint1_linear_240_14966)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0241 13.8307H31.976V16.7682H15.0241V13.8307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0241 13.8307H31.976V16.7682H15.0241V13.8307Z",
    fill: "url(#paint2_linear_240_14966)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8523 40.7515C24.633 40.7607 24.4144 40.7651 24.1976 40.7651C19.9964 40.7651 16.2726 39.0966 13.8403 37.6558C12.1547 36.6573 10.8686 35.651 10.1054 35.002C10.2677 39.8549 13.0138 44.2155 17.3546 46.4591H29.6452C34.04 44.1877 36.7985 39.7458 36.8975 34.8203C33.2875 38.5743 29.2418 40.5682 24.8523 40.7515Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8523 40.7515C24.633 40.7607 24.4144 40.7651 24.1976 40.7651C19.9964 40.7651 16.2726 39.0966 13.8403 37.6558C12.1547 36.6573 10.8686 35.651 10.1054 35.002C10.2677 39.8549 13.0138 44.2155 17.3546 46.4591H29.6452C34.04 44.1877 36.7985 39.7458 36.8975 34.8203C33.2875 38.5743 29.2418 40.5682 24.8523 40.7515Z",
    fill: "url(#paint3_linear_240_14966)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.468 12.9128C16.7587 11.372 17.1515 9.14144 18.6438 6.26251C19.1098 5.36345 19.6195 4.52571 20.0805 3.82218C19.2612 3.08753 18.1628 2.22702 17.0946 1.77979L16.6765 1.65237C16.5549 1.83331 15.633 4.00256 15.1065 6.2111C14.458 8.9315 14.3903 11.1801 14.8985 12.9128H17.468Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.468 12.9128C16.7587 11.372 17.1515 9.14144 18.6438 6.26251C19.1098 5.36345 19.6195 4.52571 20.0805 3.82218C19.2612 3.08753 18.1628 2.22702 17.0946 1.77979L16.6765 1.65237C16.5549 1.83331 15.633 4.00256 15.1065 6.2111C14.458 8.9315 14.3903 11.1801 14.8985 12.9128H17.468Z",
    fill: "url(#paint4_linear_240_14966)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3317 36.8798C16.7789 38.3262 20.5852 40.0123 24.8204 39.8341C29.2144 39.6486 33.2625 37.5209 36.8614 33.5094C36.6931 31.3226 35.995 29.2154 34.8152 27.3612C33.538 25.3543 31.7565 23.7256 29.6504 22.6362V17.6862H17.3496V22.6362C15.2435 23.7256 13.462 25.3543 12.1848 27.3612C10.9548 29.294 10.2491 31.5022 10.1209 33.7889C10.5991 34.2307 12.1281 35.5775 14.3317 36.8798Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3317 36.8798C16.7789 38.3262 20.5852 40.0123 24.8204 39.8341C29.2144 39.6486 33.2625 37.5209 36.8614 33.5094C36.6931 31.3226 35.995 29.2154 34.8152 27.3612C33.538 25.3543 31.7565 23.7256 29.6504 22.6362V17.6862H17.3496V22.6362C15.2435 23.7256 13.462 25.3543 12.1848 27.3612C10.9548 29.294 10.2491 31.5022 10.1209 33.7889C10.5991 34.2307 12.1281 35.5775 14.3317 36.8798Z",
    fill: "url(#paint5_linear_240_14966)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_240_14966",
    x1: 28.4554,
    y1: 21.5859,
    x2: 15.519,
    y2: 20.3167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A92902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#E25704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49004"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_240_14966",
    x1: 32.1107,
    y1: 21.0775,
    x2: 25.4126,
    y2: 20.7185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A92902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#E25704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49004"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_240_14966",
    x1: 31.4528,
    y1: 18.8866,
    x2: 16.7439,
    y2: 9.55362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A92902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#E25704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49004"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_240_14966",
    x1: 36.0706,
    y1: 54.8525,
    x2: 5.42705,
    y2: 47.0965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A92902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#E25704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49004"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_240_14966",
    x1: 19.9102,
    y1: 21.0333,
    x2: 13.2142,
    y2: 20.6726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A92902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#E25704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49004"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_240_14966",
    x1: 36.0361,
    y1: 55.8285,
    x2: 4.0552,
    y2: 51.5854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A92902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#E25704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49004"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuja);
export default __webpack_public_path__ + "static/media/puja.e02c5aae3ed8011510089856354c1322.svg";
export { ForwardRef as ReactComponent };